<div
  *transloco="let t; read: 'summary-feedback-dialog'"
  class="xi-modal__container summary-feedback__container"
>
  <h2 class="xi-modal__title">{{ t('feedback') }}</h2>

  <div class="xi-modal__content summary-feedback__content">
    <h3>{{ t('feedback-type') }}</h3>
    <br />
    <div class="summary-feedback__radio-group">
      <xi-radio
        class="summary-feedback-radio-option"
        name="feedbackRadio"
        value="negative"
        label="{{ t('negative-feedback') }}"
        [(ngModel)]="feedbackType"
      ></xi-radio>
      <xi-radio
        class="summary-feedback-radio-option"
        name="feedbackRadio"
        value="positive"
        label="{{ t('positive-feedback') }}"
        [(ngModel)]="feedbackType"
      ></xi-radio>
    </div>
    <br />
    <div class="xi-input-field-wrapper col-span-3">
      <xi-text-area
        label="{{ t('leave-feedback') }}"
        ngDefaultControl
        [(ngModel)]="feedbackText"
        placeholder="{{ t('feedback-placeholder') }}"
        type="text"
      ></xi-text-area>
    </div>
  </div>

  <div class="xi-modal__actions summary-feedback__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('leave-feedback-button')"
      (onClick)="onConfirm()"
    ></xi-default-button>
  </div>
</div>
